import { Application, FunctionalityType } from '@frontend/functionality/types';

import { useMenuRepository } from '../menu/menu-repository';
import type { DefaultFooterProps } from './default-footer.component';
import { nivalizFooterDisabledKeys } from './nivaliz-footer-disabled-keys';

interface ViewProps {
    currentApp: ReturnType<typeof useMenuRepository>['currentApp'];
    homeDisabled: boolean;
    activitiesDisabled: boolean;
    deceasedDisabled: boolean;
    profileDisabled: boolean;
}

const useDefaultFooter = (props: DefaultFooterProps): ViewProps => {
    const { isLoading, currentApp, getFunctionalitiesByApplication } = useMenuRepository();

    const featureDisabled =
        currentApp == null
            ? []
            : nivalizFooterDisabledKeys(
                  getFunctionalitiesByApplication(Application.NIVALIZ, currentApp === 'my' ? FunctionalityType.PERSONAL : FunctionalityType.CORPORATE)
              );

    const disabled = new Set([...(props.disabled ?? []), ...featureDisabled]);

    return {
        currentApp,
        homeDisabled: isLoading || disabled.has('home'),
        activitiesDisabled: isLoading || !currentApp || disabled.has('activities'),
        deceasedDisabled: isLoading || !currentApp || disabled.has('deceased'),
        profileDisabled: disabled.has('profile')
    };
};

export default useDefaultFooter;
